// ======================================================================
// File Name       : user
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as actionTypes from '../constants/actionTypes/user';
import { mapUserSecernIdWithGroupName } from '../utils/UserUtils';

const initialState = {
  allGroup: [],
  recordNum: 0,
  userList: [],
  groupList: [],
  courseList: [],
  childUserList: [],
  oldChildUserList: [],
  userRelationInfo: {},
  managementAuthorityList: [],
  userGroupRelations: {
    bySecernId: {},
    allSecernIds: [],
  },
  managementAuthoritys: {
    bySecernId: {},
    allSecernIds: [],
  },
  userAttributes: {
    byKeyNum: {},
    allKeyNums: [],
  },
  userInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  groupInfo: {
    bySecernId: {},
    allSecernIds: [],
  },
  groupInfoAll: {
    bySecernId: {},
    allSecernIds: [],
  },
  userSecernId: null,
  storedUserList: {},
  userListDialogRecordNum: 0,
  managementAuthoritySecernId: null,
  recordNumUserGroupRelationUserLoging: 0,
  userGroupRelationListUserLoging: [],
  integrationUser: {},
};

export default function auth(state = initialState, action) {
  switch (action.type) {
    case actionTypes.USER_COURSE_RELATION_LIST: {
      const { userCourseRelationList } = action;
      const userCourseRelation = userCourseRelationList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.courseSecernId] = cur;
          acc.allSecernIds.push(cur.courseSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ userCourseRelation },
      };
    }
    case actionTypes.USER_RECEIVE_USER_LIST: {
      const { userList, recordNum } = action;
      const userInfo = userList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.userSecernId] = cur;
          acc.allSecernIds.push(cur.userSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ userList },
        ...{ userInfo },
        ...{ recordNum },
        childUserList: [],
        oldChildUserList: [],
      };
    }
    case actionTypes.USER_RECEIVE_GROUP_LIST: {
      const { groupList } = action;
      const groupInfo = groupList && groupList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.groupSecernId] = cur;
          acc.allSecernIds.push(cur.groupSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ groupList },
        ...{ groupInfo },
      };
    }
    case actionTypes.USER_RECEIVE_AUTHORITY_LIST: {
      const { managementAuthorityList } = action;
      const managementAuthoritys = managementAuthorityList.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.managementAuthoritySecernId] = cur;
          acc.allSecernIds.push(cur.managementAuthoritySecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        ...{ managementAuthorityList, managementAuthoritys },
      };
    }
    case actionTypes.USER_RECEIVE_ATTRIBUTE_LIST: {
      const { userAttributeList } = action;
      const userAttributes = userAttributeList.reduce(
        (acc, cur) => {
          acc.byKeyNum[cur.userAttributeKeyNum] = cur;
          acc.allKeyNums.push(cur.userAttributeKeyNum);
          return acc;
        },
        {
          byKeyNum: {},
          allKeyNums: [],
        },
      );
      return {
        ...state,
        ...{ userAttributes },
      };
    }
    case actionTypes.USER_RECEIVE_GROUP_RELATION_LIST: {
      const { groupRelationList } = action;
      const { userInfo, groupInfo } = state;
      let groupInfoCheck = groupInfo;
      if (state.groupInfoAll) {
        groupInfoCheck = state.groupInfoAll;
      }
      const userList = state.userList ? [...state.userList] : [];
      userList.forEach((user) => {
        const groupRelations = [];
        let groupNames = '';
        groupRelationList.forEach((groupRelation) => {
          if (user.userSecernId === groupRelation.userSecernId) {
            groupRelations.push({ groupSecernId: groupRelation.groupSecernId });
            const group = groupInfoCheck.bySecernId[groupRelation.groupSecernId];
            if (group) {
              groupNames = groupNames === ''
                ? group.groupName
                : (groupNames += `, ${group.groupName}`);
            }
          }
        });
        user.groupRelationList = groupRelations;
        user.groupNames = groupNames;
        userInfo.bySecernId[user.userSecernId].groupRelationList = groupRelations;
      });
      return {
        ...state,
        ...{ userList, userInfo },
      };
    }
    case actionTypes.USER_RECEIVE_COURSE_LIST: {
      const { courseList } = action;
      return {
        ...state,
        ...{ courseList },
      };
    }
    case actionTypes.USER_RECEIVE_CHILD_USER_LIST: {
      const { childUserList } = action;
      const oldChildUserList = [...childUserList];
      return {
        ...state,
        ...{ childUserList },
        ...{ oldChildUserList },
      };
    }
    case actionTypes.USER_EDIT: {
      const { userSecernId } = action;
      return { ...state, userSecernId, isChangedPass: true };
    }
    case actionTypes.USER_RECEIVE_RELATION_LIST: {
      const { userRelationInfo } = action;
      return { ...state, userRelationInfo };
    }
    case actionTypes.EDIT_CHILD_USER_LIST: {
      const { childUserList } = action;
      return { ...state, childUserList };
    }
    case actionTypes.STORE_USER_LIST_ON_DIALOG: {
      const { userSearchResult, groupRelationList, groupInfo } = action;
      const { storedUserList } = state;
      let newUserList = [];
      let userListDialogRecordNum = 0;
      let groupListCheck = groupInfo;
      if (state.groupInfoAll && state.groupInfoAll.allSecernIds && state.groupInfoAll.allSecernIds.length) {
        groupListCheck = state.groupInfoAll;
      }
      if (userSearchResult && userSearchResult.userList && userSearchResult.userList.length) {
        const { userList } = userSearchResult;
        newUserList = userList.reduce((acc, cur) => {
          if (cur.userSecernId) {
            cur.groupNames = mapUserSecernIdWithGroupName(
              cur.userSecernId,
              groupRelationList,
              groupListCheck,
            );
            acc.push(cur);
            if (!storedUserList[cur.userSecernId]) {
              storedUserList[cur.userSecernId] = cur;
            }
          }
          return acc;
        }, []);
        userListDialogRecordNum = userSearchResult.recordNum || 0;
      }
      return {
        ...state,
        storedUserList,
        userListOnDialog: newUserList,
        userListDialogRecordNum,
      };
    }
    case actionTypes.STORE_MY_USER_INFO: {
      const { userInfo } = action;
      const { storedUserList } = state;
      if (userInfo && userInfo.userSecernId && !storedUserList[userInfo.userSecernId]) {
        userInfo.shouldSearchMoreInfo = true;
        storedUserList[userInfo.userSecernId] = userInfo;
      }
      return {
        ...state,
        storedUserList,
      };
    }
    case actionTypes.AUTHORITY_USER_LOGING: {
      const { data } = action;
      const { userList } = data;
      let managementAuthoritySecernId = '';
      if (userList && userList.length) {
        managementAuthoritySecernId = userList[0].managementAuthoritySecernId;
      }
      return {
        ...state,
        managementAuthoritySecernId,
      };
    }
    case actionTypes.REMOVED_DATA_USER_HAS_GROUP_AND_ROLE: {
      return {
        ...state,
        managementAuthoritySecernId: null,
        userGroupRelationListUserLoging: [],
        recordNumUserGroupRelationUserLoging: 0,
      };
    }
    case actionTypes.USER_GROUP_RELATION_USER_LOGING: {
      const { data } = action;
      const recordNumUserGroupRelationUserLoging = data.recordNum;
      let userGroupRelationListUserLoging = initialState.userGroupRelationListUserLoging;
      if (data.groupRelationList && data.groupRelationList.length) {
        userGroupRelationListUserLoging = data.groupRelationList.reduce(
          (acc, cur) => {
            const groupSecernIdObj = { groupSecernId: cur.groupSecernId };
            acc.push(groupSecernIdObj);
            return acc;
          }, []);
      }
      return {
        ...state,
        userGroupRelationListUserLoging,
        recordNumUserGroupRelationUserLoging,
      };
    }
    case actionTypes.RECEIVE_ALL_GROUP: {
      const { data } = action;
      let allGroup = [];
      if (data && data.groupList) {
        allGroup = data.groupList;
      }
      const groupInfoAll = allGroup && allGroup.reduce(
        (acc, cur) => {
          acc.bySecernId[cur.groupSecernId] = cur;
          acc.allSecernIds.push(cur.groupSecernId);
          return acc;
        },
        {
          bySecernId: {},
          allSecernIds: [],
        },
      );
      return {
        ...state,
        allGroup,
        groupInfoAll,
      };
    }
    // #7129 START
    case actionTypes.REMOVED_USER_IN_DIALOG: {
      return {
        ...state,
        userListOnDialog: [],
      };
    }
    // #7129 END
    // STEP 12.0.0 START
    case actionTypes.GET_MANAGEMENT_USER_INFO: {
      const { data } = action;
      return {
        ...state,
        integrationUser: data[0],
      };
    }
    // STEP 12.0.0 END
    default:
      return state;
  }
}
